import { OrderSummaryVM } from '../order-summary-vm';

export const OrderColumnIndex: { [key: string]: { label: string; selectFn: (order: OrderSummaryVM) => any } } = {
  tripStatus: {
    label: 'Order status',
    selectFn: (order) => {
      return order.tripStatus === 'Scheduled' ? 'Available' : order.tripStatus;
    }
  },
  tmsOrderId: {
    label: 'Order number',
    selectFn: (order) => {
      return order.tmsOrderId;
    }
  },
  bol: {
    label: 'BOL',
    selectFn: (order) => {
      return order.shipmentDetails.bolNumber;
    }
  },
  currentArrivalStatus: {
    label: 'Arrival status',
    selectFn: (order) => {
      return order.currentArrivalStatus;
    }
  },
  isAssigned: {
    label: 'Planning status',
    selectFn: (order) => {
      return order.isAssigned ? 'Assigned' : 'Unassigned';
    }
  },
  customer: {
    label: 'Customer',
    selectFn: (order) => {
      return `${order.shipmentDetails.customerName} - ${order.shipmentDetails.customerId}`;
    }
  },
  origin: {
    label: 'Origin',
    selectFn: (order) => {
      return order.origin ? order.origin.name + ', ' + order.origin.cityState : '';
    }
  },
  originEta: {
    label: 'ETA to origin',
    selectFn: (order) => {
      return order.origin && order.origin.scheduledETA ? order.origin.scheduledETA.replace('T', ' ') : '';
    }
  },
  nextStop: {
    label: 'Next stop',
    selectFn: (order) => {
      return order.nextStop ? order.nextStop.name + ',' + order.nextStop.cityState : '';
    }
  },
  nextStopEta: {
    label: 'ETA to next stop',
    selectFn: (order) => {
      return order.nextStop && order.nextStop.scheduledETA ? order.nextStop.scheduledETA.replace('T', ' ') : '';
    }
  },
  destination: {
    label: 'Destination',
    selectFn: (order) => {
      return order.destination ? order.destination.name + ',' + order.destination.cityState : '';
    }
  },
  destinationEta: {
    label: 'ETA to destination',
    selectFn: (order) => {
      return order.destination && order.destination.scheduledETA
        ? order.destination.scheduledETA.replace('T', ' ')
        : '';
    }
  },
  completedStops: {
    label: 'Completed stops',
    selectFn: (order) => {
      return order.completedStops;
    }
  },
  remainingStops: {
    label: 'Stops remaining',
    selectFn: (order) => {
      return order.remainingStops;
    }
  },
  remainingMilesToNextStop: {
    label: 'Distance to next stop',
    selectFn: (order) => {
      return order.remainingMilesToNextStop;
    }
  },
  tempRange: {
    label: 'Temp range',
    selectFn: (order) => {
      return `${order.trailer.tempMin} to ${order.trailer.tempMax}`;
    }
  },
  sensor1: {
    label: 'Sensor 1',
    selectFn: (order) => {
      return order.trailer.sensor1 || '';
    }
  },
  sensor2: {
    label: 'Sensor 2',
    selectFn: (order) => {
      return order.trailer.sensor2 || '';
    }
  },
  sensor3: {
    label: 'Sensor 3',
    selectFn: (order) => {
      return order.trailer.sensor3 || '';
    }
  },
  returnAir1: {
    label: 'RA1',
    selectFn: (order) => {
      return order.trailer.returnAir1 || '';
    }
  },
  returnAir2: {
    label: 'RA2',
    selectFn: (order) => {
      return order.trailer.returnAir2 || '';
    }
  },
  returnAir3: {
    label: 'RA3',
    selectFn: (order) => {
      return order.trailer.returnAir3 || '';
    }
  },
  lastUpdatedDate: {
    label: 'Last updated temp date',
    selectFn: (order) => {
      return order.trailer.lastUpdatedDate || '';
    }
  },
  pickupTime: {
    label: 'Scheduled pick-up date/time',
    selectFn: (order) => {
      return order.origin ? order.origin.scheduledArrivalTime.replace('T', ' ') : '';
    }
  },
  deliveryTime: {
    label: 'Scheduled delivery date/time',
    selectFn: (order) => {
      return order.destination ? order.destination.scheduledArrivalTime.replace('T', ' ') : '';
    }
  },
  tractor: {
    label: 'Tractor',
    selectFn: (order) => {
      return order.tractor.tractorNumber || '';
    }
  },
  trailer: {
    label: 'Trailer',
    selectFn: (order) => {
      return order.trailer.trailerId || '';
    }
  }
};
